import React, { 
    useState, 
    useEffect 
} from 'react';
import { 
    Col, 
    Row, 
    Card, 
    Button 
} from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import axios from 'axios';

// componentes
import Registro from './Registro';
import Parametros from './Parametros';
import Carregador from './../../Componentes/Carregador';
import ModalConfirmar from '../../Componentes/ModalConfirmar';
import PaginacaoComponente from './../../Componentes/Paginacao';

export default function Consultar(){

    // estados
    const history = useHistory();
    const [parametros, alterarParametros] = useState({
        pagina: 1,
        registrosPorPagina: 10,
        ativo: ['S'],
        texto: '',
        estados: [],
        dataProgramadoInicio: null,
        dataProgramadoFim: null
    });
    const [consulta, alterarConsulta] = useState([]);
    const [carregando, mostrarCarregando] = useState(false);
    const [totalRegistros, atualizarTotalRegistros] = useState(0);
    const [cancelandoEmails, alterarCancelandoEmails] = useState(false);
    const [mostrarAlertaCancelamentoEmail, alterarMostrarAlertaCancelamentoEmail] = useState(false);    

    // consulta emails enviados pelo sistema
    async function consultarEmailsEnviados() {
        // ativa carregamento
        mostrarCarregando(true);

        try {

            // faz a requisição para consultar os emails enviados no backend
            const { data } = await axios.get('/emailsEnviado', {
                params: parametros
            });

            // altera estados com os registros
            alterarConsulta(data.registros);
            atualizarTotalRegistros(parseInt(data.totalRegistros));

        } catch(e) {
            console.error(e);
        } finally {
            // desativa o carregamento
            mostrarCarregando(false);
        }
    }

    // cancela envio dos emails em massa
    async function cancelarEnvioDeEmailsEmMassa() {
        // ativa o carregamento do botao
        alterarCancelandoEmails(true);

        // desativa alerta cancelamento
        alterarMostrarAlertaCancelamentoEmail(false);

        try {

            // faz a requisição para o backend cancelar o envio dos emails
            await axios.post('/emailsEnviado/massa/cancelar');

            // mostra toast de sucesso
            toast(({ closeToast }) => <>
                <div className="toast-header">
                    <strong className="mr-auto">Emails cancelados!</strong>
                    <button
                        onClick={closeToast}
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="toast-body">
                    Emails disparados em massa foran cancelados com sucesso
                </div>
            </>, { autoClose: 5000 });

            // consulta os emails novamente
            consultarEmailsEnviados();

        } catch(e) {
            console.error(e);

            if(e?.response?.data) {
                // resgata primeira chave do erro
                const erroChave = Object.keys(e.response.data)[0];
                
                // mensagem de erro
                toast(<>
                    <div style={{ background: '#ff6271' }}>
                        <div className="toast-header">
                            <strong className="mr-auto">Erro ao cancelar emails!</strong>
                            <button
                                className="ml-2 mb-1 close btn-outline-light outline-0"
                            >
                            </button>
                        </div>
                        <div className="toast-body text-light">
                            <p>{e.response.data[erroChave]}</p>                            
                        </div>
                    </div>
                </>);
            }
        } finally {
            // desativa carregamento
            alterarCancelandoEmails(false);
        }
    }

    // inicia
    useEffect(() => {
        consultarEmailsEnviados();
    }, [parametros]);

    return (
        <>
            <Row>
                <Col>
                    <Card className="painel-consulta border-0 shadow-sm" >
                        <div className="card-header">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <h4 className="card-title font-weight-bolder">Caixa de Saída de emails</h4>
                                <div>
                                    <Button 
                                        variant="danger"                                     
                                        className='text-nowrap mr-4'
                                        onClick={() => alterarMostrarAlertaCancelamentoEmail(true)}
                                    >
                                        Cancelar envio em massa
                                    </Button>
                                    <Button 
                                        variant='padrao'
                                        onClick={() => history.push('/painel/modelos-email')}
                                    >
                                        <FontAwesomeIcon 
                                            className="icone" 
                                            icon={["far", 'envelope']} 
                                        />
                                        <span>Modelos de email</span>
                                    </Button>
                                </div>
                            </div>
                            <Parametros 
                                parametros={parametros} 
                                alterarParametros={alterarParametros} 
                            />
                        </div>
                        <Card.Body>                        
                            <table className="table table-hover tabela">
                                <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Título</th>
                                        <th>Para</th>
                                        <th>Data</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {consulta.map((registro, a) => 
                                        <Registro 
                                            key={registro.id}
                                            dados={registro}
                                            clicouAbrir={() => {
                                                history.push(`/painel/clientes/abrir-email/${registro.id}`);
                                            }}
                                        />
                                    )}
                                </tbody>
                            </table>
                            <PaginacaoComponente
                                pagina={parametros.pagina}
                                registrosPorPagina={parametros.registrosPorPagina}
                                totalRegistros={totalRegistros}
                                alterouPagina={(pagina) => {
                                    alterarParametros({...parametros, pagina: pagina});
                                }}
                            />
                            {carregando && 
                                <Carregador className="rounded-bottom" />
                            }
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ModalConfirmar
                mostrar={mostrarAlertaCancelamentoEmail}
                titulo={'Cancelar emails'}
                texto={`Você deseja cancelar o envio de emails disparados em massa?`}
                clicouCancelar={() => alterarMostrarAlertaCancelamentoEmail(false)}
                clicouConfirmar={cancelarEnvioDeEmailsEmMassa}
                carregando={cancelandoEmails}
            />
        </>
    )
}
